<template>
	<ul class="menu">
		<li v-for="(item,index) in menuList">
			<div class="parent-item" :class="[item.id==curNameId?'active':'']"  @click="toDetail(item)">
				<i class="el-icon-caret-bottom" :class="[item.isShowChild?'':'transform']" @click.stop="isHideMenu(item)" v-if="item.list&&item.list.length>0"></i>
				<i class="el-icon" v-else></i>
				<a class="anchor-link-title" >{{item.categoryName}}</a>
			</div>
			<asideDocument :current="curNameId" v-on="$listeners"  v-if="item.list&&item.list.length>0&&item.isShowChild" :menuList="item.list"></asideDocument>
		</li>
	</ul>
</template>

<script>
	export default {
		name: 'AsideDocument',
		props: {
			menuList: {
				type: Array,
				default: []
			},
			current: {
				type: Number
			}
		},
		data(){
			return {
				curNameId: 0
			}
		},
		watch: {
			//监听当前点击节点的id
			current: {
				handler(num) {
					this.curNameId = num
				},
				deep: true,
				immediate: true
			}
		},
		methods: {
			isHideMenu(item){
				console.log(item.isShowChild)
				item.isShowChild = !item.isShowChild
			},
			toDetail(item){
				this.currentId = item.id
				console.log(item)
				console.log(item.id)
				console.log('=====')
				this.$emit('toDetail', {
					id: item.id,
					parentId: item.parentId||'',
					title: item.categoryName
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.menu{
		li{
			min-height: 32px !important;
			line-height: 32px;
			.parent-item{
				display: flex;
				align-items: center;
				position: relative;
				border-left: 2px solid #f0f0f0;
				transition: border .1s ease-in-out;
				i{
					display: block;
					width:14px;
					height: 14px;
					margin: 0 5px;
				}
				i.transform{
					transform: rotate(-90deg);
				}
			}
			.active{
				margin-left: -1px;
				border-left: 3px solid #DE0515;
				a{
					color: rgba(0, 0, 0, 1)
				}
			}
			a{
				color: rgba(0, 0, 0, .5)
			}
			cursor: pointer
		}
	}
</style>
